import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { A3EnlaceContableRequest } from '../../models/a3/a3.model';

const A3_ENDPOINT = '/a3/';

@Injectable({
  providedIn: 'root',
})
export class A3Service {
  constructor(private http: HttpClient) {}

  public getA3SuenlaceInvoiceReceived(
    request: A3EnlaceContableRequest
  ): Observable<Blob> {
    return this.http
      .post(environment.apiUrl + A3_ENDPOINT + 'export/invoicesreceived', request, {
        responseType: 'blob' as 'json',
      })
      .pipe(
        map((response) => new Blob([response as any], { type: 'application/pdf' })),
        catchError(() => of(null))
      );
  }

  public getA3SuenlaceInvoiceIssued(
    request: A3EnlaceContableRequest
  ): Observable<Blob> {
    return this.http
      .post(environment.apiUrl + A3_ENDPOINT + 'export/invoicesissued', request, {
        responseType: 'blob' as 'json',
      })
      .pipe(
        map((response) => new Blob([response as any], { type: 'application/pdf' })),
        catchError(() => of(null))
      );
  }

  public getA3SuenlaceDeposits(
    request: A3EnlaceContableRequest
  ): Observable<Blob> {
    return this.http
      .post(environment.apiUrl + A3_ENDPOINT + 'export/deposits', request, {
        responseType: 'blob' as 'json',
      })
      .pipe(
        map((response) => new Blob([response as any], { type: 'application/pdf' })),
        catchError(() => of(null))
      );
  }
}